import { z } from "zod";

// ─── Sub-schemas ─────────────────────────────────────────────────────────────

export const DashboardKpisSchema = z.object({
  avgReviewSpeed: z.number(),
  interviewRate: z.number(),
  ninetyDayRetention: z.number(),
});
export type DashboardKpis = z.infer<typeof DashboardKpisSchema>;

export const DashboardPipelineSchema = z.object({
  submitted: z.number().int(),
  reviewing: z.number().int(),
  interview: z.number().int(),
  offered: z.number().int(),
  hired: z.number().int(),
  benched: z.number().int(),
  rejected: z.number().int(),
});
export type DashboardPipeline = z.infer<typeof DashboardPipelineSchema>;

// ─── Response Schemas ─────────────────────────────────────────────────────────

export const DashboardResponseSchema = z.object({
  kpis: DashboardKpisSchema,
  pipeline: DashboardPipelineSchema,
  total: z.number().int().nonnegative(),
});
export type DashboardResponse = z.infer<typeof DashboardResponseSchema>;
